import { render, staticRenderFns } from "./ProductProcess.vue?vue&type=template&id=22e38afc&"
import script from "./ProductProcess.vue?vue&type=script&lang=js&"
export * from "./ProductProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports